

<template>
  <div class="card-headerfrm" style="margin-bottom: 15px;">
          <h4 class="header"><i class="fa fa-bars barcolor" aria-hidden="true"></i>&nbsp;Shipment Details <span style="color: red; font-size: 13px;">(Total Records : {{shipmentData.totalCount}})</span></h4>
          <vue-element-loading spinner="line-scale" color="#FF6700" />
          <div style="overflow-x:auto">
          <table class="table-bordered table-hover tbl datatables">
            <thead>
              <tr class="text-primary">
                <th class="text-center tableheader"><b>Parent AWB Number</b></th>
                <th class="text-center tableheader"><b>MPS Number</b></th>
                <th class="text-center tableheader"><b>Region</b></th>
                <th class="text-center tableheader"><b>Current Hub</b></th>
                <th class="text-center tableheader"><b>Origin HubName</b></th>
                <th class="text-center tableheader"><b>Damage Hub</b></th>
                <th class="text-center tableheader"><b>Damage Type</b></th>
                <th class="text-center tableheader"><b>Status</b></th>
                <th class="text-center tableheader"><b>Modified by</b></th>
                <th class="text-center tableheader"><b>Modified date</b></th>
                <th v-if="showActionColumn" class="text-center tableheader"><b>Action</b></th>
  
  
              </tr>
            </thead>
            <tbody >
              <tr v-if="shipmentData.totalCount==0">
                <td colspan="31" style="color: red;" align="center">No record found</td>
              </tr>
               <tr v-for="data in shipmentData">
                <td>{{data.parentawbnumber}}</td>
                <td>{{data.shippingid}}</td>
                <td>{{data.ZoneName}}</td>
                <td>{{data.currenthubName}}</td>
                <td>{{data.originhubName}}</td>
                <td>{{data.damagehubName}}</td>
                <td>{{damageType[data.damagetype]}}</td>
                <td>{{data.StatusName}}</td>
                <td>{{data.lastmodifiedby ? data.lastmodifiedby : data.createdby}}</td>
                <td>{{data.lastmodifieddate ? new Date(data.lastmodifieddate).toLocaleDateString() : new Date(data.createddate).toLocaleDateString()}}</td>
                <td v-if="showActionColumn">
                    <b-link v-if="visibility(data.status)" class="btn btn-sm btn-info" @click="$emit('UpdatePage',data.shippingid,data.status)">Action</b-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div><br>
        </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'

export default {
  name: 'resultGrid',
  components: {
        VueElementLoading
    },
  props: {
    shipmentData: {
      type: Array,
      required: true
    },
    showActionColumn: {
      type: Boolean,
      required: true
    }
  },data() {
    return {
      damageType: {},
    }
  },
  mounted() {
    this.damageType = {
      1 : 'Minor',
      2 : 'Major'
    }
  },
  methods:{
    visibility(status){
      let visible = true;
      if(status === 8 || status === 7){
        visible = false;
      }
      return visible;
    }
  }
}
</script>

<style>
.card-headerfrm{
  margin-bottom: 15px;
  border: none;
}
</style>


// WEBPACK FOOTER //
// src/views/B2B components/resultGrid.vue?395887f8